// Copyright 2021 Sorama B.V.

import { bindable, bindingMode, customElement, observable } from "aurelia-framework";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import { IUserSettingsService } from "services/UserManagement/IUserSettingsService";

@customElement("pop-up")
export class PopUp {
    private static popupGroupKey = "PopUp";
    private static popupPropertyKey = "notShowNextTime";

    @observable
    private isChecked = false;

    /**
     * An unique id to store the state of this control in cache. Only required when operating mode is not "always"
     */
    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public popupUniqueId?: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    private popupLink?: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    private popupImage?: string;

    public popupClosed = false;

    @bindable({ defaultBindingMode: bindingMode.oneTime })
    public showMode: "always" | "once" | "user" = "always";

    private businessUnitId: string;

    constructor(
        private readonly userSettingsService: IUserSettingsService,
        private readonly shellviewManager: ShellViewManager
    ) {}

    public bind(): void {
        if (this.showMode !== "always") {
            let promise = Promise.resolve();

            promise = this.userSettingsService
                .hasKey(PopUp.popupGroupKey + this.popupUniqueId, PopUp.popupPropertyKey)
                .then((isAvailable) => {
                    if (isAvailable) {
                        return this.userSettingsService
                            .get(PopUp.popupGroupKey + this.popupUniqueId, PopUp.popupPropertyKey)
                            .then((x) => {
                                this.popupClosed = x == "true";
                            });
                    }
                });

            if (this.showMode === "once") {
                promise.then(() => this.setNotShowingNextTime(true));
            }
        }
    }

    public setNotShowingNextTime(notShowNextTime: boolean): void {
        if (this.showMode !== "always") {
            this.userSettingsService.set(
                PopUp.popupGroupKey + this.popupUniqueId,
                PopUp.popupPropertyKey,
                notShowNextTime ? "true" : "false"
            );
        }
    }
}
